import axios from "axios";
import { getItem, makeUrl } from "../../app/common/util/genericUtils";

export const labelPrintingApiCall = id => {
  const token = getItem("suprolUser");
  return axios({
    method: "GET",
    url: makeUrl("/orders/envelope-data/" + id),
    headers: {
      Authorization: `Token ${token.auth_token}`
    }
  });
};
